import axios from "axios";
import store from '../store/index'
import EosUtils from "../utils/EosUtils";

const errorApiCount = {}

const errorHandler = (error) => {
    const status = error.response ? error.response.status : null
    if (status && status === 401) {
        refreshToken(store).then(() => {
            error.config.baseURL = undefined;

            var key = error.config.url
            var count = errorApiCount[key] || 0
            errorApiCount[key] = count + 1

            //console.log(errorApiCount);

            if (Number(count) < 4) {// repeat count
                return axios.request(error.config);
            } else {
                store.dispatch('logout')
            }
        });
    }
    return Promise.reject({ ...error })
}

async function refreshToken(store) {
    var username = store.state.auth.auth?.username || ''
    if (EosUtils.isWebKartAdmin()) {
        username = "Admin"
    }
    const headers = {

        'token': `${store.state.auth.auth?.token || ''}`,
        'username': username,
    }
    ApiService.setHeader(headers);
}

const ApiService = {
    timeout: 60 * 1000,

    async init() {
        //var appSettings = new AppSettings();
        //Vue.use(VueAxios, axios);
        //axios.defaults.baseURL = "http://192.168.92.1:8080/";
        //axios.defaults.baseURL = "http://192.168.10.139:8081/";
        //axios.defaults.baseURL = "https://webcartapi.elmosanat.com/";
        //axios.defaults.baseURL = "http://localhost:14758/";

        /*await fetch("config.json")
        .then((r) => r.json())
        .then((response) => {
          console.log(response);
          if (response.baseURL) {
            axios.defaults.baseURL = response.baseURL;
          }
        });*/
        //await store.dispatch('getLocalConfig')

        axios.interceptors.response.use(
            response => response,
            error => errorHandler(error)
        )

        // declare a request interceptor
        axios.interceptors.request.use(config => {
            // perform a task before the request is sent
            //console.log(config);
            config.timeout = this.timeout
            return config;
        }, error => {
            return Promise.reject(error);
        });

        axios.defaults.timeout = this.timeout;

        refreshToken(store)
    },

    setHeader(headers) {
        axios.defaults.headers.common['token'] = `${headers.token}`;
        axios.defaults.headers.common['username'] = `${headers.username}`;
    },

    clearAuthHeader() {
        axios.defaults.headers.common['token'] = '';
        axios.defaults.headers.common['username'] = '';
    },

    get(resource, params = {}, headers = {}) {
        return axios({
            method: 'get',
            url: `${resource}`,
            headers: headers,
            params: params,
            //timeout: this.timeout
        });
    },

    post(resource, data, params, headers) {
        

        return axios({
            method: 'post',
            url: `${resource}`,
            headers: headers,
            data: data,
            params: params
        });
    },

    postFormData(resource, formData) {
        /*const headers = { 'Content-Type': 'multipart/form-data' };
        return axios.post(`${resource}`, formData, { headers })*/
        return axios.post(`${resource}`, formData)
    },
};

export default ApiService;


